/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Scalar for BigDecimal */
  BigDecimal: { input: number; output: number };
  /** Scalar for BigInteger */
  BigInteger: { input: number; output: number };
};

export type AktivierungQueryManagerNotFound = {
  __typename?: 'AktivierungQueryManagerNotFound';
  managerEmail?: Maybe<Scalars['String']['output']>;
};

export type AktivierungQueryNotAllowed = {
  __typename?: 'AktivierungQueryNotAllowed';
  msg?: Maybe<Scalars['String']['output']>;
};

export type AktivierungQueryResult =
  | AktivierungQueryManagerNotFound
  | AktivierungQueryNotAllowed
  | Aktivierungszustand;

export type Aktivierungszustand = {
  __typename?: 'Aktivierungszustand';
  aktiv: Scalars['Boolean']['output'];
  gesperrt: Scalars['Boolean']['output'];
  uidStandortgruppe?: Maybe<Scalars['ID']['output']>;
  /** Aktive Verträge der Standortgruppe, auf die die API gebucht werden kann. */
  vertraege: Array<Vertrag>;
  /** Vertrag, auf den die API gebucht ist. Leer, wenn keiner gewählt wurde. */
  vertragsnummer: Scalars['String']['output'];
};

export type AktivierungszustandUebersicht = {
  __typename?: 'AktivierungszustandUebersicht';
  aktiv: Scalars['Boolean']['output'];
  gesperrt: Scalars['Boolean']['output'];
  uidStandortgruppe?: Maybe<Scalars['ID']['output']>;
};

export type ApiAktivierenGesperrt = {
  __typename?: 'ApiAktivierenGesperrt';
  msg?: Maybe<Scalars['String']['output']>;
};

export type ApiAktivierenManagerNotFound = {
  __typename?: 'ApiAktivierenManagerNotFound';
  managerEmail?: Maybe<Scalars['String']['output']>;
};

export type ApiAktivierenNotAllowed = {
  __typename?: 'ApiAktivierenNotAllowed';
  msg?: Maybe<Scalars['String']['output']>;
};

export type ApiAktivierenResult =
  | ApiAktivierenGesperrt
  | ApiAktivierenManagerNotFound
  | ApiAktivierenNotAllowed
  | ApiAktivierenStandortgruppeNichtGefunden
  | ApiAktivierenSuccess
  | ApiAktivierenVertragNichtGefunden;

export type ApiAktivierenStandortgruppeNichtGefunden = {
  __typename?: 'ApiAktivierenStandortgruppeNichtGefunden';
  msg?: Maybe<Scalars['String']['output']>;
};

export type ApiAktivierenSuccess = {
  __typename?: 'ApiAktivierenSuccess';
  msg?: Maybe<Scalars['String']['output']>;
};

/** Der Vertrag ist kein aktiver Vertrag der Standortgruppe. */
export type ApiAktivierenVertragNichtGefunden = {
  __typename?: 'ApiAktivierenVertragNichtGefunden';
  vertragsnummer?: Maybe<Scalars['String']['output']>;
};

export type ApiDeaktivierenAktivierungNotFound = {
  __typename?: 'ApiDeaktivierenAktivierungNotFound';
  msg?: Maybe<Scalars['String']['output']>;
};

export type ApiDeaktivierenManagerNotFound = {
  __typename?: 'ApiDeaktivierenManagerNotFound';
  managerEmail?: Maybe<Scalars['String']['output']>;
};

export type ApiDeaktivierenNotAllowed = {
  __typename?: 'ApiDeaktivierenNotAllowed';
  msg?: Maybe<Scalars['String']['output']>;
};

export type ApiDeaktivierenResult =
  | ApiDeaktivierenAktivierungNotFound
  | ApiDeaktivierenManagerNotFound
  | ApiDeaktivierenNotAllowed
  | ApiDeaktivierenStandortgruppeNotFound
  | ApiDeaktivierenSuccess;

export type ApiDeaktivierenStandortgruppeNotFound = {
  __typename?: 'ApiDeaktivierenStandortgruppeNotFound';
  msg?: Maybe<Scalars['String']['output']>;
};

export type ApiDeaktivierenSuccess = {
  __typename?: 'ApiDeaktivierenSuccess';
  msg?: Maybe<Scalars['String']['output']>;
};

export type ApiSperrenAktivierungNotFound = {
  __typename?: 'ApiSperrenAktivierungNotFound';
  uidStandortgruppe?: Maybe<Scalars['String']['output']>;
};

export type ApiSperrenResult =
  ApiSperrenAktivierungNotFound | ApiSperrenSuccess;

export type ApiSperrenSuccess = {
  __typename?: 'ApiSperrenSuccess';
  uidStandortgruppe?: Maybe<Scalars['String']['output']>;
};

export type EndpunktDefinition = {
  __typename?: 'EndpunktDefinition';
  attribute: Array<Scalars['String']['output']>;
  endpunktName: Scalars['String']['output'];
  httpMethode: HttpMethode;
  uidZugang: Scalars['String']['output'];
};

export type EndpunktDefinitionInput = {
  attribute: Array<Scalars['String']['input']>;
  endpunktName: Scalars['String']['input'];
  httpMethode: HttpMethode;
};

export type HttpMethode = 'DELETE' | 'GET' | 'POST' | 'PUT';

export type KatalogAttribut = {
  __typename?: 'KatalogAttribut';
  beschreibung: Scalars['String']['output'];
  name: Scalars['String']['output'];
  typ: Scalars['String']['output'];
};

export type KatalogEndpunkt = {
  __typename?: 'KatalogEndpunkt';
  anzeigename: Scalars['String']['output'];
  /** Leer, wenn der Endpunkt keine Attributauswahl anbietet. */
  attribute: Array<KatalogAttribut>;
  beschreibung: Scalars['String']['output'];
  /** Fasst verwandte Endpunkte zusammen, z.B. „Personal“. */
  gruppe: Scalars['String']['output'];
  httpMethode: HttpMethode;
  name: Scalars['String']['output'];
};

export type KatalogProfil = 'FULL' | 'STANDARD';

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  /** Aktiviert die API und bucht sie auf den Vertrag. Ein zuvor gewählter Vertrag wird überschrieben. */
  aktiviereApi: ApiAktivierenResult;
  /** Aktiviert den Zugang, der dazugehörige API-Key wird wieder von der e2n API akzeptiert. */
  aktiviereZugang: ZugangAktivierungResult;
  /** Bearbeite den Zugang. */
  bearbeiteZugang: ZugangBearbeitenResult;
  deaktiviereApi: ApiDeaktivierenResult;
  /** Deaktiviert den Zugang, der API-Key wird von der API abgewiesen. */
  deaktiviereZugang: ZugangAktivierungResult;
  erstelleZugang: ZugangErstellenResult;
  /** Löscht den Zugang samt seiner Endpunkt-Definitionen und entfernt den dazugehörigen API-Key. */
  loescheZugang: ZugangLoeschenResult;
  saveEndpunktDefinitionen: SaveEndpunktDefinitionResult;
  sperreApi: Array<ApiSperrenResult>;
};

/** Mutation root */
export type MutationAktiviereApiArgs = {
  vertragsnummer: Scalars['String']['input'];
};

/** Mutation root */
export type MutationAktiviereZugangArgs = {
  uidZugang: Scalars['String']['input'];
};

/** Mutation root */
export type MutationBearbeiteZugangArgs = {
  zugangBearbeitenInput: ZugangBearbeitenInput;
};

/** Mutation root */
export type MutationDeaktiviereZugangArgs = {
  uidZugang: Scalars['String']['input'];
};

/** Mutation root */
export type MutationErstelleZugangArgs = {
  zugangErstellenInput?: InputMaybe<ZugangErstellenInput>;
};

/** Mutation root */
export type MutationLoescheZugangArgs = {
  uidZugang: Scalars['String']['input'];
};

/** Mutation root */
export type MutationSaveEndpunktDefinitionenArgs = {
  endpunktDefinitionen: Array<EndpunktDefinitionInput>;
  zugangUid: Scalars['String']['input'];
};

/** Mutation root */
export type MutationSperreApiArgs = {
  uidStandortgruppen: Array<Scalars['String']['input']>;
};

export type PartnerTemplate = {
  __typename?: 'PartnerTemplate';
  anzeigename: Scalars['String']['output'];
  beschreibung: Scalars['String']['output'];
  template: Template;
};

/** Query root */
export type Query = {
  __typename?: 'Query';
  aktivierung: AktivierungQueryResult;
  aktivierungszustaende: Array<Maybe<AktivierungszustandUebersicht>>;
  /** Erhalte alle Endpunkte und Attribute, die für einen Zugang freigeschaltet werden können. */
  katalog: Array<KatalogEndpunkt>;
  /** Erhalte alle Zugänge für die Standortgruppe des Managers. */
  zugaenge: ZugangQueryResult;
  /** Erhalte alle Zugänge der übergebenen Uids. */
  zugang: ZugangQueryResult;
};

/** Query root */
export type QueryAktivierungszustaendeArgs = {
  uidStandortgruppes: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Query root */
export type QueryKatalogArgs = {
  profil?: InputMaybe<KatalogProfil>;
};

/** Query root */
export type QueryZugangArgs = {
  uidZugang: Array<Scalars['String']['input']>;
};

/** Der Zugang gehört zu einer anderen Standortgruppe als die des Managers. */
export type SaveEndpunktDefinitionNoAccessToZugang = {
  __typename?: 'SaveEndpunktDefinitionNoAccessToZugang';
  zugangId?: Maybe<Scalars['String']['output']>;
};

export type SaveEndpunktDefinitionNotAllowed = {
  __typename?: 'SaveEndpunktDefinitionNotAllowed';
  msg?: Maybe<Scalars['String']['output']>;
};

export type SaveEndpunktDefinitionResult =
  | SaveEndpunktDefinitionNoAccessToZugang
  | SaveEndpunktDefinitionNotAllowed
  | SaveEndpunktDefinitionSuccess
  | SaveEndpunktDefinitionUnknownAttribute
  | SaveEndpunktDefinitionUnknownEndpunktName
  | SaveEndpunktDefinitionZugangNotEditable
  | SaveEndpunktDefinitionZugangNotFound;

export type SaveEndpunktDefinitionSuccess = {
  __typename?: 'SaveEndpunktDefinitionSuccess';
  msg?: Maybe<Scalars['String']['output']>;
};

/** Ein Attribut für diesen Endpunkt ist nicht im Katalog zu finden. */
export type SaveEndpunktDefinitionUnknownAttribute = {
  __typename?: 'SaveEndpunktDefinitionUnknownAttribute';
  attribute: Array<Scalars['String']['output']>;
  endpunktName?: Maybe<Scalars['String']['output']>;
};

export type SaveEndpunktDefinitionUnknownEndpunktName = {
  __typename?: 'SaveEndpunktDefinitionUnknownEndpunktName';
  endpunktName?: Maybe<Scalars['String']['output']>;
};

/** Der Zugang stammt aus einem Partner-Template, seine Endpunkte sind nicht konfigurierbar. */
export type SaveEndpunktDefinitionZugangNotEditable = {
  __typename?: 'SaveEndpunktDefinitionZugangNotEditable';
  zugangId?: Maybe<Scalars['String']['output']>;
};

export type SaveEndpunktDefinitionZugangNotFound = {
  __typename?: 'SaveEndpunktDefinitionZugangNotFound';
  zugangId?: Maybe<Scalars['String']['output']>;
};

export type Template =
  'DATABITES' | 'E2NDISPLAY' | 'FULL' | 'INPRAXI' | 'PMS' | 'POS' | 'PROTABO';

export type Vertrag = {
  __typename?: 'Vertrag';
  kundennummer: Scalars['Int']['output'];
  unternehmensname: Scalars['String']['output'];
  vertragsnummer: Scalars['String']['output'];
};

export type Zugang = {
  __typename?: 'Zugang';
  aktiv: Scalars['Boolean']['output'];
  apiKey: Scalars['String']['output'];
  beschreibung: Scalars['String']['output'];
  endpunktDefinitionen: Array<EndpunktDefinition>;
  /** Der Zugang stammt aus einem Partner-Template. Die Endpunkte sind damit vorkonfiguriert und nicht editierbar. */
  partnerTemplate?: Maybe<PartnerTemplate>;
  uid: Scalars['ID']['output'];
  uidStandortgruppe: Scalars['ID']['output'];
};

export type ZugangAktivierungManagerNotFound = {
  __typename?: 'ZugangAktivierungManagerNotFound';
  managerEmail: Scalars['String']['output'];
};

/** Der Zugang gehört zu einer anderen Standortgruppe als die des Managers. */
export type ZugangAktivierungNoAccessToZugang = {
  __typename?: 'ZugangAktivierungNoAccessToZugang';
  uidZugang: Scalars['String']['output'];
};

export type ZugangAktivierungNotAllowed = {
  __typename?: 'ZugangAktivierungNotAllowed';
  msg: Scalars['String']['output'];
};

export type ZugangAktivierungResult =
  | ZugangAktivierungManagerNotFound
  | ZugangAktivierungNoAccessToZugang
  | ZugangAktivierungNotAllowed
  | ZugangAktivierungSuccess
  | ZugangAktivierungZugangNotFound;

export type ZugangAktivierungSuccess = {
  __typename?: 'ZugangAktivierungSuccess';
  zugang: Zugang;
};

export type ZugangAktivierungZugangNotFound = {
  __typename?: 'ZugangAktivierungZugangNotFound';
  uidZugang: Scalars['String']['output'];
};

export type ZugangBearbeitenBeschreibungTooLong = {
  __typename?: 'ZugangBearbeitenBeschreibungTooLong';
  maxAllowedLength: Scalars['Int']['output'];
};

export type ZugangBearbeitenInput = {
  beschreibung?: InputMaybe<Scalars['String']['input']>;
  uidZugang: Scalars['String']['input'];
};

export type ZugangBearbeitenManagerNotFound = {
  __typename?: 'ZugangBearbeitenManagerNotFound';
  managerEmail: Scalars['String']['output'];
};

/** Der Zugang gehört zu einer anderen Standortgruppe als die des Managers. */
export type ZugangBearbeitenNoAccessToZugang = {
  __typename?: 'ZugangBearbeitenNoAccessToZugang';
  uidZugang: Scalars['String']['output'];
};

export type ZugangBearbeitenNotAllowed = {
  __typename?: 'ZugangBearbeitenNotAllowed';
  msg: Scalars['String']['output'];
};

export type ZugangBearbeitenResult =
  | ZugangBearbeitenBeschreibungTooLong
  | ZugangBearbeitenManagerNotFound
  | ZugangBearbeitenNoAccessToZugang
  | ZugangBearbeitenNotAllowed
  | ZugangBearbeitenSuccess
  | ZugangBearbeitenZugangNotEditable
  | ZugangBearbeitenZugangNotFound;

export type ZugangBearbeitenSuccess = {
  __typename?: 'ZugangBearbeitenSuccess';
  zugang: Zugang;
};

/** Der Zugang stammt aus einem Partner-Template und ist nicht bearbeitbar. */
export type ZugangBearbeitenZugangNotEditable = {
  __typename?: 'ZugangBearbeitenZugangNotEditable';
  uidZugang: Scalars['String']['output'];
};

export type ZugangBearbeitenZugangNotFound = {
  __typename?: 'ZugangBearbeitenZugangNotFound';
  uidZugang: Scalars['String']['output'];
};

export type ZugangErstellenApiNotActivated = {
  __typename?: 'ZugangErstellenApiNotActivated';
  uidStandortgruppe?: Maybe<Scalars['String']['output']>;
};

export type ZugangErstellenBeschreibungTooLong = {
  __typename?: 'ZugangErstellenBeschreibungTooLong';
  maxAllowedLength: Scalars['Int']['output'];
};

export type ZugangErstellenInput = {
  /** Wird bei einem Partnerzugang ignoriert, dieser übernimmt die Beschreibung des Templates. */
  beschreibung?: InputMaybe<Scalars['String']['input']>;
  /** Erstellt einen Partnerzugang aus dem Template. */
  template?: InputMaybe<Template>;
};

export type ZugangErstellenLimitReached = {
  __typename?: 'ZugangErstellenLimitReached';
  zugangLimit: Scalars['Int']['output'];
};

export type ZugangErstellenManagerNotFound = {
  __typename?: 'ZugangErstellenManagerNotFound';
  managerEmail?: Maybe<Scalars['String']['output']>;
};

export type ZugangErstellenNotAllowed = {
  __typename?: 'ZugangErstellenNotAllowed';
  msg?: Maybe<Scalars['String']['output']>;
};

export type ZugangErstellenResult =
  | ZugangErstellenApiNotActivated
  | ZugangErstellenBeschreibungTooLong
  | ZugangErstellenLimitReached
  | ZugangErstellenManagerNotFound
  | ZugangErstellenNotAllowed
  | ZugangErstellenStandortgruppeNichtGefunden
  | ZugangErstellenSuccess
  | ZugangErstellenTemplateNotSelectable;

export type ZugangErstellenStandortgruppeNichtGefunden = {
  __typename?: 'ZugangErstellenStandortgruppeNichtGefunden';
  uidStandortGruppe?: Maybe<Scalars['String']['output']>;
};

export type ZugangErstellenSuccess = {
  __typename?: 'ZugangErstellenSuccess';
  zugang: Zugang;
};

/** Das Template wird nicht über die Manager-Oberfläche vergeben. */
export type ZugangErstellenTemplateNotSelectable = {
  __typename?: 'ZugangErstellenTemplateNotSelectable';
  template: Scalars['String']['output'];
};

export type ZugangLoeschenManagerNotFound = {
  __typename?: 'ZugangLoeschenManagerNotFound';
  managerEmail: Scalars['String']['output'];
};

/** Der Zugang gehört zu einer anderen Standortgruppe als die des Managers. */
export type ZugangLoeschenNoAccessToZugang = {
  __typename?: 'ZugangLoeschenNoAccessToZugang';
  uidZugang: Scalars['String']['output'];
};

export type ZugangLoeschenNotAllowed = {
  __typename?: 'ZugangLoeschenNotAllowed';
  msg: Scalars['String']['output'];
};

export type ZugangLoeschenResult =
  | ZugangLoeschenManagerNotFound
  | ZugangLoeschenNoAccessToZugang
  | ZugangLoeschenNotAllowed
  | ZugangLoeschenSuccess
  | ZugangLoeschenZugangNotFound;

export type ZugangLoeschenSuccess = {
  __typename?: 'ZugangLoeschenSuccess';
  zugang: Zugang;
};

export type ZugangLoeschenZugangNotFound = {
  __typename?: 'ZugangLoeschenZugangNotFound';
  uidZugang: Scalars['String']['output'];
};

export type ZugangQueryNotAllowed = {
  __typename?: 'ZugangQueryNotAllowed';
  msg?: Maybe<Scalars['String']['output']>;
};

export type ZugangQueryResult = ZugangQueryNotAllowed | ZugangQuerySuccess;

export type ZugangQuerySuccess = {
  __typename?: 'ZugangQuerySuccess';
  zugaenge: Array<Zugang>;
  /** Wie viele Zugänge die Standortgruppe insgesamt anlegen darf. */
  zugangLimit: Scalars['Int']['output'];
};

export type E2nApiAktiviereApiMutationVariables = Exact<{
  vertragsnummer: Scalars['String']['input'];
}>;

export type E2nApiAktiviereApiMutation = {
  __typename?: 'Mutation';
  aktiviereApi:
    | { __typename: 'ApiAktivierenGesperrt' }
    | { __typename: 'ApiAktivierenManagerNotFound' }
    | { __typename: 'ApiAktivierenNotAllowed' }
    | { __typename: 'ApiAktivierenStandortgruppeNichtGefunden' }
    | { __typename: 'ApiAktivierenSuccess' }
    | { __typename: 'ApiAktivierenVertragNichtGefunden' };
};

export type E2nApiDeaktiviereApiMutationVariables = Exact<{
  [key: string]: never;
}>;

export type E2nApiDeaktiviereApiMutation = {
  __typename?: 'Mutation';
  deaktiviereApi:
    | { __typename: 'ApiDeaktivierenAktivierungNotFound' }
    | { __typename: 'ApiDeaktivierenManagerNotFound' }
    | { __typename: 'ApiDeaktivierenNotAllowed' }
    | { __typename: 'ApiDeaktivierenStandortgruppeNotFound' }
    | { __typename: 'ApiDeaktivierenSuccess' };
};

export type E2nApiAktiviereZugangMutationVariables = Exact<{
  uidZugang: Scalars['String']['input'];
}>;

export type E2nApiAktiviereZugangMutation = {
  __typename?: 'Mutation';
  aktiviereZugang:
    | { __typename: 'ZugangAktivierungManagerNotFound' }
    | { __typename: 'ZugangAktivierungNoAccessToZugang' }
    | { __typename: 'ZugangAktivierungNotAllowed' }
    | { __typename: 'ZugangAktivierungSuccess' }
    | { __typename: 'ZugangAktivierungZugangNotFound' };
};

export type E2nApiDeaktiviereZugangMutationVariables = Exact<{
  uidZugang: Scalars['String']['input'];
}>;

export type E2nApiDeaktiviereZugangMutation = {
  __typename?: 'Mutation';
  deaktiviereZugang:
    | { __typename: 'ZugangAktivierungManagerNotFound' }
    | { __typename: 'ZugangAktivierungNoAccessToZugang' }
    | { __typename: 'ZugangAktivierungNotAllowed' }
    | { __typename: 'ZugangAktivierungSuccess' }
    | { __typename: 'ZugangAktivierungZugangNotFound' };
};

export type E2nApiLoescheZugangMutationVariables = Exact<{
  uidZugang: Scalars['String']['input'];
}>;

export type E2nApiLoescheZugangMutation = {
  __typename?: 'Mutation';
  loescheZugang:
    | { __typename: 'ZugangLoeschenManagerNotFound' }
    | { __typename: 'ZugangLoeschenNoAccessToZugang' }
    | { __typename: 'ZugangLoeschenNotAllowed' }
    | { __typename: 'ZugangLoeschenSuccess' }
    | { __typename: 'ZugangLoeschenZugangNotFound' };
};

export type E2nApiErstelleZugangMutationVariables = Exact<{
  input?: InputMaybe<ZugangErstellenInput>;
}>;

export type E2nApiErstelleZugangMutation = {
  __typename?: 'Mutation';
  erstelleZugang:
    | { __typename: 'ZugangErstellenApiNotActivated' }
    | {
        __typename: 'ZugangErstellenBeschreibungTooLong';
        maxAllowedLength: number;
      }
    | { __typename: 'ZugangErstellenLimitReached'; zugangLimit: number }
    | { __typename: 'ZugangErstellenManagerNotFound' }
    | { __typename: 'ZugangErstellenNotAllowed' }
    | { __typename: 'ZugangErstellenStandortgruppeNichtGefunden' }
    | {
        __typename: 'ZugangErstellenSuccess';
        zugang: {
          __typename?: 'Zugang';
          uid: string;
          aktiv: boolean;
          apiKey: string;
          beschreibung: string;
          endpunktDefinitionen: Array<{
            __typename?: 'EndpunktDefinition';
            endpunktName: string;
            httpMethode: HttpMethode;
            attribute: Array<string>;
          }>;
        };
      }
    | { __typename: 'ZugangErstellenTemplateNotSelectable' };
};

export type E2nApiBearbeiteZugangMutationVariables = Exact<{
  input: ZugangBearbeitenInput;
}>;

export type E2nApiBearbeiteZugangMutation = {
  __typename?: 'Mutation';
  bearbeiteZugang:
    | {
        __typename: 'ZugangBearbeitenBeschreibungTooLong';
        maxAllowedLength: number;
      }
    | { __typename: 'ZugangBearbeitenManagerNotFound' }
    | { __typename: 'ZugangBearbeitenNoAccessToZugang' }
    | { __typename: 'ZugangBearbeitenNotAllowed' }
    | {
        __typename: 'ZugangBearbeitenSuccess';
        zugang: {
          __typename?: 'Zugang';
          uid: string;
          aktiv: boolean;
          apiKey: string;
          beschreibung: string;
          endpunktDefinitionen: Array<{
            __typename?: 'EndpunktDefinition';
            endpunktName: string;
            httpMethode: HttpMethode;
            attribute: Array<string>;
          }>;
        };
      }
    | { __typename: 'ZugangBearbeitenZugangNotEditable' }
    | { __typename: 'ZugangBearbeitenZugangNotFound' };
};

export type E2nApiSaveEndpunktDefinitionenMutationVariables = Exact<{
  zugangUid: Scalars['String']['input'];
  endpunktDefinitionen:
    Array<EndpunktDefinitionInput> | EndpunktDefinitionInput;
}>;

export type E2nApiSaveEndpunktDefinitionenMutation = {
  __typename?: 'Mutation';
  saveEndpunktDefinitionen:
    | { __typename: 'SaveEndpunktDefinitionNoAccessToZugang' }
    | { __typename: 'SaveEndpunktDefinitionNotAllowed' }
    | { __typename: 'SaveEndpunktDefinitionSuccess' }
    | { __typename: 'SaveEndpunktDefinitionUnknownAttribute' }
    | { __typename: 'SaveEndpunktDefinitionUnknownEndpunktName' }
    | { __typename: 'SaveEndpunktDefinitionZugangNotEditable' }
    | { __typename: 'SaveEndpunktDefinitionZugangNotFound' };
};

export type E2nApiGetAktivierungQueryVariables = Exact<{
  [key: string]: never;
}>;

export type E2nApiGetAktivierungQuery = {
  __typename?: 'Query';
  aktivierung:
    | { __typename: 'AktivierungQueryManagerNotFound' }
    | { __typename: 'AktivierungQueryNotAllowed' }
    | { __typename: 'Aktivierungszustand'; aktiv: boolean; gesperrt: boolean };
};

export type E2nApiGetVertraegeQueryVariables = Exact<{ [key: string]: never }>;

export type E2nApiGetVertraegeQuery = {
  __typename?: 'Query';
  aktivierung:
    | { __typename: 'AktivierungQueryManagerNotFound' }
    | { __typename: 'AktivierungQueryNotAllowed' }
    | {
        __typename: 'Aktivierungszustand';
        vertraege: Array<{
          __typename?: 'Vertrag';
          vertragsnummer: string;
          kundennummer: number;
          unternehmensname: string;
        }>;
      };
};

export type E2nApiGetZugaengeQueryVariables = Exact<{ [key: string]: never }>;

export type E2nApiGetZugaengeQuery = {
  __typename?: 'Query';
  zugaenge:
    | { __typename: 'ZugangQueryNotAllowed' }
    | {
        __typename: 'ZugangQuerySuccess';
        zugangLimit: number;
        zugaenge: Array<{
          __typename?: 'Zugang';
          uid: string;
          aktiv: boolean;
          apiKey: string;
          beschreibung: string;
          partnerTemplate?: {
            __typename?: 'PartnerTemplate';
            anzeigename: string;
            beschreibung: string;
          } | null;
          endpunktDefinitionen: Array<{
            __typename?: 'EndpunktDefinition';
            endpunktName: string;
            httpMethode: HttpMethode;
            attribute: Array<string>;
          }>;
        }>;
      };
};

export type E2nApiGetKatalogQueryVariables = Exact<{ [key: string]: never }>;

export type E2nApiGetKatalogQuery = {
  __typename?: 'Query';
  katalog: Array<{
    __typename?: 'KatalogEndpunkt';
    name: string;
    anzeigename: string;
    beschreibung: string;
    gruppe: string;
    httpMethode: HttpMethode;
    attribute: Array<{
      __typename?: 'KatalogAttribut';
      name: string;
      beschreibung: string;
      typ: string;
    }>;
  }>;
};

export const E2nApiAktiviereApiDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'E2nApiAktiviereApi' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'vertragsnummer' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aktiviereApi' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vertragsnummer' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'vertragsnummer' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiAktiviereApiMutation,
  E2nApiAktiviereApiMutationVariables
>;
export const E2nApiDeaktiviereApiDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'E2nApiDeaktiviereApi' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deaktiviereApi' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiDeaktiviereApiMutation,
  E2nApiDeaktiviereApiMutationVariables
>;
export const E2nApiAktiviereZugangDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'E2nApiAktiviereZugang' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'uidZugang' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aktiviereZugang' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uidZugang' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'uidZugang' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiAktiviereZugangMutation,
  E2nApiAktiviereZugangMutationVariables
>;
export const E2nApiDeaktiviereZugangDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'E2nApiDeaktiviereZugang' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'uidZugang' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deaktiviereZugang' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uidZugang' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'uidZugang' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiDeaktiviereZugangMutation,
  E2nApiDeaktiviereZugangMutationVariables
>;
export const E2nApiLoescheZugangDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'E2nApiLoescheZugang' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'uidZugang' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loescheZugang' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uidZugang' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'uidZugang' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiLoescheZugangMutation,
  E2nApiLoescheZugangMutationVariables
>;
export const E2nApiErstelleZugangDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'E2nApiErstelleZugang' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ZugangErstellenInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'erstelleZugang' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'zugangErstellenInput' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ZugangErstellenSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zugang' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'aktiv' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'apiKey' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'beschreibung' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'endpunktDefinitionen',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'endpunktName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'httpMethode',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ZugangErstellenLimitReached',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zugangLimit' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ZugangErstellenBeschreibungTooLong',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxAllowedLength' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiErstelleZugangMutation,
  E2nApiErstelleZugangMutationVariables
>;
export const E2nApiBearbeiteZugangDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'E2nApiBearbeiteZugang' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ZugangBearbeitenInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bearbeiteZugang' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'zugangBearbeitenInput' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ZugangBearbeitenSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zugang' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'aktiv' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'apiKey' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'beschreibung' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'endpunktDefinitionen',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'endpunktName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'httpMethode',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ZugangBearbeitenBeschreibungTooLong',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxAllowedLength' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiBearbeiteZugangMutation,
  E2nApiBearbeiteZugangMutationVariables
>;
export const E2nApiSaveEndpunktDefinitionenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'E2nApiSaveEndpunktDefinitionen' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'zugangUid' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'endpunktDefinitionen' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'EndpunktDefinitionInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveEndpunktDefinitionen' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'zugangUid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'zugangUid' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endpunktDefinitionen' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'endpunktDefinitionen' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiSaveEndpunktDefinitionenMutation,
  E2nApiSaveEndpunktDefinitionenMutationVariables
>;
export const E2nApiGetAktivierungDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'E2nApiGetAktivierung' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aktivierung' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Aktivierungszustand' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'aktiv' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gesperrt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiGetAktivierungQuery,
  E2nApiGetAktivierungQueryVariables
>;
export const E2nApiGetVertraegeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'E2nApiGetVertraege' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aktivierung' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Aktivierungszustand' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vertraege' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'vertragsnummer' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kundennummer' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'unternehmensname' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiGetVertraegeQuery,
  E2nApiGetVertraegeQueryVariables
>;
export const E2nApiGetZugaengeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'E2nApiGetZugaenge' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'zugaenge' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ZugangQuerySuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zugangLimit' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zugaenge' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'aktiv' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'apiKey' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'beschreibung' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'partnerTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'anzeigename',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'beschreibung',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'endpunktDefinitionen',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'endpunktName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'httpMethode',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attribute' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiGetZugaengeQuery,
  E2nApiGetZugaengeQueryVariables
>;
export const E2nApiGetKatalogDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'E2nApiGetKatalog' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'katalog' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'profil' },
                value: { kind: 'EnumValue', value: 'STANDARD' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'anzeigename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'beschreibung' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'gruppe' } },
                { kind: 'Field', name: { kind: 'Name', value: 'httpMethode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attribute' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beschreibung' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'typ' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  E2nApiGetKatalogQuery,
  E2nApiGetKatalogQueryVariables
>;
